/**
 * Die Landingpage liegt unter LANDING_PATH und ist dort immer erreichbar —
 * bewusst abseits der Hauptdomain, damit Nutzer, die karsconnection.de
 * aufrufen, weiterhin beim Login landen.
 *
 * LANDING_PUBLIC schaltet sie zusätzlich unter / frei (Entwicklung oder
 * VITE_SHOW_LANDING=true) und blendet die Links auf die Landingpage in
 * Header, Footer und App-Unterseiten ein. Ohne Freischaltung leitet / auf
 * /einloggen um; /preise und /apps/* bleiben unabhängig davon öffentlich.
 */
export const LANDING_PATH = '/landingpage'
/** Eigene Seite der Plattform mit allen Apps; wie die Landingpage nur per Direktlink. */
export const CONNECTION_PATH = '/kars-connection'
export const LANDING_PUBLIC = import.meta.env.DEV || import.meta.env.VITE_SHOW_LANDING === 'true'
